<template>
	<div id="page">
		<div class="ml" v-for="(item,index) in iteminfo" :key="index">
			 <ul>
				<li>
					 <a>{{$route.params.index}}</a>
					 <div class="ml1">
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/gzs.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px; color: rgb(124, 122, 122);">国度工作室</p>
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/rl.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">{{item.date|filterdate}}</p>
							 <img style="width: 17px; height: 17px; margin-top: 15px;margin-left: 15px; float: left;" src="~assets/images/ml.png" alt="">
							 <p style="font-size: 13px;float: left; margin-top: 14px; margin-left: 5px;color: rgb(124, 122, 122);">{{$route.params.id}}</p>
					 </div>
				</li>   
			 </ul>
		</div>
		<!--文字下载部分  -->

		<div v-for="item in iteminfo" class="info">
		 <Editor
				style="width: 100%;"
				v-model="item.content"
				:defaultConfig="editorConfig"
				:mode="mode"
		 />
		 <a :href="item.url"><el-button style="margin-top: 80px;margin-bottom:370px;" type="primary" icon="el-icon-download">点我下载</el-button></a>
		</div>
		 
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Editor} from '@wangeditor/editor-for-vue'
	import { IEditorConfig } from '@wangeditor/editor'
	
	export default Vue.extend({
		name:'page',
		props:{
			iteminfo:{
				type:Array,
				default:[]
			}
		},
		data() {
			return {
					editor: null,
					html2:'',
					toolbarConfig: {},
					editorConfig: { 
						placeholder: '暂无内容',
						scroll : false,
						readOnly:true
					},
					mode: 'default', // or 'simple'
			}
		},

		created() {
		},
		components: { Editor},
	})
</script>

<style scoped>

	/* 编程工具 */
	.ml{
	    /* border: solid 2px #000000; */
			
			padding: 15px;
	}
	.ml ul li{
			text-align: center;

	    border-bottom: solid 2px #c0c0c0;
	    margin-top: 5px;
	    height: 70px;
	    /* width: 720px; */
	    font-weight: bold;
	}
	.ml ul li a{
	    text-decoration: none;
	    letter-spacing:1px;
	    margin-left: 20px;
			font-size: 20px;
			
	}
	.ml1 {
		width: 400px;
		/* border: solid 2px #000000; */
		margin: 0 auto;
		padding-left: 32px;
	}
	.info{
		padding: 15px;
	}	
</style>